import React from 'react';
import GTMDataLayer from './gtm';

const FilterAudience = (props) => {

  const handleAudienceFilter = (e) => {
    if (e.target.value) {
      props.setFilters({...props.filters, audience: e.target.value, page: 0});

      // Get name of the selected audience for GTM.
      const selectedAudience = props.audience.find(item => item.id == e.target.value);

      // Track blog audience changes.
      GTMDataLayer({
        event: 'blog_filter_audience',
        pageUrl: location.href,
        filter_audience: selectedAudience ? selectedAudience.name : 'All'
      });
    }
  };

  return (
    <div className='filter-audience'>
      <h3>{Drupal.t('Audience')}</h3>
      <div>
        <select onChange={handleAudienceFilter} defaultValue={props.selected} id="audience-filter">
          <option value='all'>{Drupal.t('All')}</option>
          {props.audience.map((item, i) => (
            <option key={i} value={item.id}>{item.name}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default FilterAudience;